var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66667V10L11.6667 11.6667",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9439 4.38997C6.30429 3.14693 8.07471 2.44823 9.91736 2.42719C11.76 2.40614 13.5459 3.06422 14.9343 4.27586C16.3228 5.4875 17.2165 7.16789 17.4451 8.99644C17.6737 10.825 17.221 12.6737 16.1736 14.1898C15.1261 15.7059 13.5572 16.7834 11.766 17.2165C9.97489 17.6497 8.08697 17.4083 6.46246 16.5384C4.83794 15.6685 3.59056 14.2309 2.95829 12.5M2.54163 16.6667V12.5H6.70829",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.cbb12e2614b469b902b17d814be69f72.svg";
export { ForwardRef as ReactComponent };